import styled from 'styled-components';

const VolumeMeter = styled.meter`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  width: 100%;
`;

export default {
  VolumeMeter,
};
